import React from "react";
import { ImgWrapper, MainSection, ReadBtn, Text, Title } from "./elements";
import {
  DarkButton,
  LightButton,
  MainCol,
  MainContainer,
  MainRow,
} from "components/common";
import { Image } from "react-bootstrap";
import { whitelist } from "assets";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
const WhitePaperComp = () => {
  return (
    <MainSection id="whitepaper">
      <MainContainer>
        <MainRow>
          <MainCol lg={6}>
            <AnimationOnScroll animateIn="animate__fadeInLeft">
              <Title>Explore Our Whitepaper</Title>

              <Text>
                Our comprehensive whitepaper examines versatility and mass
                appeal behind the <span>enterapp.io</span>
                <br />
                <br />
                Dive into the details of our comprehensive solution and discover
                how <span>enterapp.io</span> is designed to reshape the future
                of financial transactions.
                <br />
                <br />
                Read & study our whitepaper and be a part of our Project!
              </Text>
              <div className="btn-div">
                <DarkButton btnText="enterapp.io Whitepaper" arrowIcon={true} />
              </div>
            </AnimationOnScroll>
          </MainCol>

          <MainCol lg={6}>
            <AnimationOnScroll animateIn="animate__fadeInRight">
              <ImgWrapper>
                <Image src={whitelist} fluid />
              </ImgWrapper>
            </AnimationOnScroll>
          </MainCol>
        </MainRow>
      </MainContainer>
    </MainSection>
  );
};

export default WhitePaperComp;
